<!--
 * @Author: Haotian Zheng
 * @Date: 2023-07-13 19:27:45
 * @Descripttion:
 * @LastEditors: cuicuizi
 * @LastEditTime: 2024-05-21 17:58:08
-->
<!-- 公共top部分 -->
<template>
    <div class="topWrap" v-if="token">
        <div class="topBox">
            <div class="top">
                <div class="selectBox">
                    <el-select popper-class="chenge-select-box" v-model.number="onTenantId" @change="selectCompany" placeholder="请选择企业" ref="cascader"
                        @visible-change="(v) => visibleChange(v, 'cascader')">
                        <el-option v-for="(item, index) in companyList" :key="index" :label="item.tenantName" :value="item.id"
                            :disabled="item.userStatus == 2"></el-option>
                    </el-select>
                </div>
                <div class="personalBox">
                    <div class="item" @click="toMessagePage">
                        <div class="messafeImg">
                            <img class="messafeImg" src="../assets/image/header/header_message.png" alt="" />
                            <!-- 红点 -->
                            <i v-if="noReadMessageCount > 0"></i>
                        </div>
                        <span>消息中心</span>
                    </div>
                    <div class="line"></div>
                    <div class="item" @click="toHelpCenterPage">
                        <img class="helpImg" src="../assets/image/header/header_help.png" alt="" />
                        <span>帮助中心</span>
                    </div>
                    <div class="line"></div>
                    <div class="item drag-box">
                        <img v-if="store.headPortraitUrl" class="photoImg" :src="store.headPortraitUrl" alt="" />
                        <img v-else class="photoImg" src="../assets/image/header/photo.png" alt="" />
                        <span class="name">{{ store.name }}</span>
                        <div class="drag-list-container">
                            <div class="drag-list-box">
                                <div v-if="tenantId">
                                    <router-link to="/userSetting" tag="div" class="drag-item-btn">个人信息</router-link>
                                    <router-link to="/userSetting/userSafe" tag="div" class="drag-item-btn">账号安全</router-link>
                                </div>
                                <div v-else>
                                    <div tag="div" class="drag-item-btn">
                                        个人信息
                                    </div>
                                    <div tag="div" class="drag-item-btn">
                                        账号安全
                                    </div>
                                </div>
                                <div @click="exitLogin" class="drag-item-btn">退出登录</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 消息提示 -->
        <transition name="el-fade-in-linear">
            <qff-message v-if="qffMessageShow" :qffMessage="qffMessage" @exitDialog="qffMessageShow = false"></qff-message>
        </transition>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { getTenantList, getCurrentEmployeeSimpleInfo, selectTenant, getUserInfo } from '@/api/apis_user.js'
import { getNoReadMessageCount } from '@/api/apis_message.js'
import { logout } from '../api/apis_login.js'
import { store } from '@/store/store'
import { getMenuList } from '@/api/apis_header.js'
import { getHelpClassifyList } from '@/api/apis_help_center'
import qffMessage from '@/components/qffMessage.vue'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { qffMessage },
  data() {
    //这里存放数据
    return {
      qffMessageShow: false, //qff消息展示
      qffMessage: {
        message: '这是一条提示信息',
        type: 'none',
      },
      store,
      userInfo: {},
      onTenantId: '',
      noReadMessageCount: 0,
      companyList: [],
      helpCenterId: '',
      roleList: [],
    }
  },
  //监听属性 类似于data概念
  computed: {
    companySimple() {
      return localStorage.getItem('companySimple') + ''
    },
    currentEmployeeSimpleInfo() {
      return JSON.parse(localStorage.getItem('currentEmployeeSimpleInfo'))
    },
    tenantId() {
      return localStorage.getItem('tenantId')
    },
    token() {
      return localStorage.getItem('token')
    },
    messageSwitch() {
      return this.store.messageSwitch
    },
    userStatus() {
      return localStorage.getItem('userStatus')
    },
  },
  //监控data中的数据变化
  watch: {
    tenantId() {
      this.onTenantId = parseInt(this.tenantId)
    },
    messageSwitch() {
      this.getNoReadMessageCount()
    },
  },
  //方法集合
  methods: {
    // 打开消息提示框
    openMessage(type, message) {
      this.qffMessage = {
        type: type,
        message: message,
      }
      this.qffMessageShow = true
      setTimeout(() => {
        this.qffMessageShow = false
      }, 2000)
    },
    async getMenuList() {
      let { data } = await getMenuList()
      this.roleList = data?.data || []
    },
    // 判断roleList中的选项内resourceName 是否有传入参数
    isRoleList(name) {
      let isRole = false
      this.roleList.forEach((item) => {
        if (item.resourceName == name) {
          isRole = true
        }
      })
      return isRole
    },
    //退出登录
    async exitLogin() {
      const { data } = await logout()
      if (data.code === 200) {
        // 跳转登录页
        this.$router.push('/login')
        // 清空local
        localStorage.removeItem('tenantId')
        localStorage.removeItem('companySimple')
        localStorage.removeItem('currentEmployeeSimpleInfo')
        localStorage.removeItem('token')
        localStorage.removeItem('userStatus')
      }
    },
    visibleChange(visible, refName, onClick) {
      if (visible) {
        const ref = this.$refs[refName]
        let popper = ref.$refs.popper
        if (popper.$el) popper = popper.$el
        if (!Array.from(popper.children).some((v) => v.className === 'el-cascader-menu__list')) {
          const el = document.createElement('ul')
          el.className = 'el-cascader-menu__list'
          el.style = ' padding:14px 16px;color: #606266;cursor: pointer'
          el.innerHTML = `<li class="el-cascader-node" style="width:100%;height:34px;background: #F7F8FA;border: 1px solid #DADEE4;border-radius: 4px 4px 4px 4px;line-height:34px;text-align:center;display:block;font-size: 14px;color: #1A1A1A;">创建企业</li>`
          popper.appendChild(el)
          el.onclick = () => {
            // this.addCategoryValue = true
            this.toAddPage()
            setTimeout(() => {
              // document.querySelector('#anchor').scrollIntoView(true)
              document.querySelector('#anchor')
            }, 100) // 因为我控制隐藏是用的v-if  所以第一次进来获取不到才加的延时
          }
        }
      }
      // 解决创建企业成功，选择企业下方未展示新创建的企业名称，需刷新平台后才展示的问题
      this.getList(true)
    },
    // 获取帮助中心分类列表
    async getHelpClassifyList() {
      const { data } = await getHelpClassifyList({
        id: 0,
      })

      if (data.code === 200) {
        this.helpCenterId = data.data[0].id
      } else {
        this.openMessage('warning', data.message)
      }
    },
    toAddPage() {
      this.$router.push({ path: '/addCompany' })
    },
    toHelpCenterPage() {
      if (this.tenantId) {
        this.$router.push({ path: '/helpCenter/started/' + this.helpCenterId })
      }
    },
    async getNoReadMessageCount() {
      const { data } = await getNoReadMessageCount()
      this.noReadMessageCount = data.data
    },
    toMessagePage() {
      if (this.tenantId) {
        this.$router.push({ path: '/messageCenter' })
      }
    },
    selectCompany(value) {
      // 获取当前router
      if (value === 'add') {
        this.$router.push({ path: '/addCompany' })
      } else {
        this.selectTenant(value).then(() => {
          if (this.$route.path == '/staging') {
            this.$router.go(0)
          } else {
            this.$router.push('/staging').then(() => {
              this.$router.go(0)
            })
          }
        })
      }
    },
    async getList(isFirstLogin) {
      // 从local获取企业列表
      if (localStorage.getItem('companyList')) {
        this.companyList = JSON.parse(localStorage.getItem('companyList'))
      }
      const { data } = await getTenantList()
      if (data.code == 200) {
        this.companyList = data.data
        // 将companyList 存入 local
        localStorage.setItem('companyList', JSON.stringify(data.data))
        if (data.data == null) {
          this.onTenantId = ''
        } else {
          let foundObject = data.data.find((item) => item.id == this.tenantId)
          this.onTenantId = foundObject ? foundObject.id : null
          const selectedCompany = this.companyList.find((item) => item.id === this.onTenantId)
          if (selectedCompany) {
            const userStatus = selectedCompany.userStatus
            //在这里您可以做任何您需要的操作，比如使用userStatus
            if (userStatus == 2) {
              if (!this.$route.meta.isAddCompany) {
                this.$router.push({ path: '/userDisable' })
              }
            } else {
              if (this.$route.meta.isTop) {
                this.$router.push({ path: '/staging' })
              }
            }
          }
        }
        if (data.data.length === 1) {
          localStorage.setItem('companySimple', true)
          this.selectTenant(data.data[0].id, isFirstLogin)
        } else {
          localStorage.setItem('companySimple', false)
        }
      }
    },
    async selectTenant(id, isFirstLogin) {
      const { data } = await selectTenant({
        tenantId: id,
      })
      this.setTenantId(id)
      this.getCurrentEmployeeSimpleInfo().then(() => {
        // 刷新页面
        if (!isFirstLogin) {
          this.$router.push({ path: '/staging' })
        }
      })
    },
    setTenantId(id) {
      localStorage.setItem('tenantId', id)
    },
    async getCurrentEmployeeSimpleInfo() {
      const { data } = await getCurrentEmployeeSimpleInfo()
      // this.currentEmployeeSimpleInfo = data.data
      // 将userInfo 存入 local
      if (data.code === 200) {
        localStorage.setItem('currentEmployeeSimpleInfo', JSON.stringify(data.data))
        let currentRouter = this.$route.path
        if (currentRouter == '/companyDisable') {
          this.$router.push({ path: '/' })
        }
      } else {
        this.openMessage('warning', data.message)
        return false
      }
    },
    async getUserInfo() {
      const { data } = await getUserInfo()
      this.userInfo = data.data
      this.store.name = this.userInfo.name
      this.store.headPortraitUrl = this.userInfo.headPortraitUrl
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.tenantId) {
      this.onTenantId = parseInt(this.tenantId)
      this.getList(true)
      this.getCurrentEmployeeSimpleInfo()
      this.getUserInfo()
      this.getNoReadMessageCount()
      this.getHelpClassifyList()
      this.getMenuList()
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.topWrap {
  width: 100%;
  height: 44px;
  background: #141b1e;

  .topBox {
    width: 1200px;
    height: 100%;
    margin: 0 auto;

    display: flex;
    align-items: center;

    .top {
      margin-left: auto;
      display: flex;
      align-items: center;

      .selectBox {
        height: 36px;

        .el-select {
          width: 248px;
          height: 36px;
          background: rgba(216, 216, 216, 0.1);
          box-shadow: inset 0 4px 10px 0 rgba(0, 0, 0, 0.5);
          border-radius: 2px;
          border: 1px solid #4e5969;
        }
      }

      .personalBox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: 18px;
        width: 292px;

        .drag-box {
          height: 44px;
          position: relative;
          cursor: pointer;

          &:hover {
            .drag-list-container {
              display: block;
            }
          }

          .drag-list-container {
            position: absolute;
            top: 36px;
            left: -50px;
            display: none;
            padding-top: 8px;
            z-index: 999;
          }

          .drag-list-box {
            width: 180px;
            background: linear-gradient(180deg, #fffdfd 7%, #ffffff 100%);
            box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
            border-radius: 2px 2px 2px 2px;

            .drag-item-btn {
              width: 100%;
              height: 40px;
              text-align: center;
              line-height: 40px;
              font-size: 14px;
              font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
              font-weight: 400;
              color: #424242;
              cursor: pointer;

              &:hover {
                background: #f7f8fa;
                color: #be1a21;
              }

              &.disable {
                color: #aaa;
                cursor: not-allowed;

                &:hover {
                  background: #fff;
                  color: #aaa;
                }
              }
            }
          }
        }

        .item {
          display: flex;
          align-items: center;
          cursor: pointer;

          img {
            margin-right: 4px;
          }

          .messafeImg {
            position: relative;
            width: 18px;
            height: 18px;
            margin-right: 5px;

            img {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
            }

            i {
              position: absolute;
              top: 1px;
              right: -1px;

              width: 6px;
              height: 6px;
              background: linear-gradient(180deg, #ff4c4c 0%, #be1a21 100%);
              border-radius: 50%;
            }
          }

          .helpImg {
            width: 15px;
            height: 15px;
          }

          .photoImg {
            width: 28px;
            height: 28px;
            margin-right: 11px;
            border-radius: 50%;
          }

          span {
            height: 17px;
            font-size: 12px;
            font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
            color: #ffffff;
            line-height: 17px;
          }

          .name {
            height: 20px;
            font-size: 14px;
            font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
            font-weight: 400;
            color: #ffffff;
            line-height: 20px;
          }
        }

        .line {
          width: 1px;
          height: 22px;
          background-color: #3b4143;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.topWrap {
  .topBox {
    .top {
      .el-select {
        .el-input {
          width: 100%;
          height: 100%;
          padding: 0;
          border: none;

          .el-input__inner {
            width: 100%;
            height: 100%;
            padding: 0 0 0 15px;
            border: none;
            background-color: transparent;

            font-size: 14px;
            font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
            color: #ffffff;
            line-height: 36px;
          }

          // .el-input__suffix {
          //     display: none;
          // }

          .el-input__icon {
            line-height: 34px !important;
          }
        }
      }
    }
  }
}

.chenge-select-box {
  .el-cascader-node {
    &:hover {
      color: #be1a21 !important;
      border: 1px solid #be1a21 !important;
    }
  }

  .el-select-dropdown__item.selected {
    color: #be1a21 !important;
    // border: 1px solid #BE1A21 !important;
  }

  .el-select-dropdown__item.hover {
    color: #be1a21 !important;
    // border: 1px solid #BE1A21 !important;
  }
}
</style>
